import { Spinner } from "../../shared/ui";

// ── Truth or Dare Host Screen ─────────────────────────────────────────────────
// Props:
//   player   : string | null  — current player's name
//   type     : "truth" | "dare" | null  — null = player is choosing
//   content  : string | null  — question or dare text
//   done     : bool           — completed successfully
//   skipped  : bool           — player refused
//   players  : object[]       — full player list (to get color)
//   tv       : bool

export default function TruthDareHost({ player, type, content, done, skipped, players, tv }) {
  const pd = players.find(p => p.name === player);

  if (!player) return <Spinner color="#FF7700" tv={tv} />;

  return (
    <div className="w-full text-center animate-slide-up">
      {/* Current player chip */}
      <div className="mb-5">
        <div className="font-heading text-[#aaa] mb-2" style={{ fontSize: tv ? "1.35rem" : "0.9rem" }}>
          Сейчас ходит:
        </div>
        <div style={{
          display: "inline-block", backgroundColor: pd?.color || "#FF7700",
          border: "3px solid #000", borderRadius: "1.25rem", boxShadow: "5px 5px 0 #000",
          padding: tv ? "0.8rem 2.75rem" : "0.55rem 1.75rem",
        }}>
          <span className="font-heading" style={{ fontSize: tv ? "2.75rem" : "1.6rem", color: "#000" }}>
            {player}
          </span>
        </div>
      </div>

      {/* Choosing state */}
      {!type ? (
        <div>
          <div style={{ fontSize: tv ? "7rem" : "4.5rem", animation: "wiggle 0.7s ease-in-out infinite" }}>🔥</div>
          <div className="font-heading text-white" style={{ fontSize: tv ? "2.25rem" : "1.35rem" }}>
            {player} выбирает...
          </div>
          <div className="font-body text-[#aaa] mt-1" style={{ fontSize: tv ? "1.35rem" : "0.9rem" }}>
            Правда или Действие?
          </div>
        </div>
      ) : (
        /* Task card */
        <div style={{
          background: "#1e0845", border: "3px solid #000", borderRadius: "1.5rem",
          boxShadow: "6px 6px 0 #000", padding: tv ? "2.5rem" : "1.25rem",
          maxWidth: tv ? "820px" : "100%", margin: "0 auto",
        }}>
          {/* Type badge */}
          <div style={{
            display: "inline-block",
            background: type === "truth" ? "#00FFFF" : "#FF7700",
            border: "3px solid #000", borderRadius: "9999px", boxShadow: "3px 3px 0 #000",
            padding: tv ? "0.65rem 2.25rem" : "0.45rem 1.35rem", marginBottom: "1.25rem",
          }}>
            <span className="font-heading" style={{
              fontSize: tv ? "1.75rem" : "1.1rem",
              color: type === "truth" ? "#000" : "#fff",
            }}>
              {type === "truth" ? "🤔 ПРАВДА" : "🔥 ДЕЙСТВИЕ"}
            </span>
          </div>

          <h2 className="font-heading text-white leading-tight" style={{
            fontSize: tv ? "2.5rem" : "1.35rem", marginBottom: "1rem",
          }}>
            {content}
          </h2>

          {/* Result */}
          {done && (
            <div className="animate-bounce-in">
              <div style={{ fontSize: tv ? "4rem" : "2.5rem" }}>✅</div>
              <div className="font-heading" style={{
                color: "#3dffa0", fontSize: tv ? "1.75rem" : "1.1rem", textShadow: "2px 2px 0 #000",
              }}>
                Выполнено! +50 очков
              </div>
            </div>
          )}
          {skipped && !done && (
            <div className="animate-bounce-in">
              <div style={{ fontSize: tv ? "4rem" : "2.5rem" }}>😬</div>
              <div className="font-heading" style={{
                color: "#ff3355", fontSize: tv ? "1.75rem" : "1.1rem", textShadow: "2px 2px 0 #000",
              }}>
                Отказался! −25 очков
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
